'use strict';

/**
 * @param {string|null|undefined} postalCode
 * @param {{ postal_code?: string, city?: string, region_code?: string }|null|undefined} location
 * @returns {string}
 */
function formatHeaderDisplayPostal(postalCode, location) {
	const z = postalCode || location?.postal_code;
	if (z) {
		return z;
	}
	if (location?.city && location?.region_code) {
		return `${location.city}, ${location.region_code}`;
	}
	return '';
}

module.exports = {
	formatHeaderDisplayPostal,
};
